import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

export function useCopyShortcut(onCopy: (ids: string[]) => void) {
  const { getNodes } = useReactFlow();
  useKeyboardShortcut({ key: 'c', meta: true }, () => {
    const selected = getNodes().filter((n) => n.selected).map((n) => n.id);
    if (selected.length === 0) return;
    onCopy(selected);
  });
}
